import { signal } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { Subject } from 'rxjs';
import { TColumn } from './column.model';

const _grouping = signal<TColumn[]>([]);
export const groupingSignal = _grouping.asReadonly();

let sortedPoints: string[] = [];

const _groupingChange$ = new Subject<void>();
export const groupingChange$ = _groupingChange$.asObservable();

// GET

export const GET_GROUPING = (): TColumn[] => _grouping();

// SET & MODIFY

export const SET_GROUPING = (grouping: TColumn[]): void => {
  _grouping.set(grouping);
  _groupingChange$.next();
};

// CLEAR

export const CLEAR_GROUPING = (): void => {
  _grouping.set([]);
  _groupingChange$.next();
};

export const SET_GROUPED_POINTS = (sortedPointIds: string[]): void => {
  sortedPoints = sortedPointIds;
};

export const GET_GROUPED_POINTS = (): string[] => sortedPoints;

export const REMOVE_GROUP = (column: TColumn): void => {
  const next = _grouping().filter((_column) => _column.index !== column.index);

  next.forEach((_column, _index) => {
    _column.groupIndex = _index;
  });

  _grouping.set(next);
  _groupingChange$.next();
};

export const REPLACE_GROUP = (column: TColumn, oldColumn: TColumn): void => {
  const current = _grouping();
  const indexToDelete = current.findIndex((_column) => _column.index === oldColumn.index);
  const next = [...current];

  next.splice(indexToDelete, 1, column);

  _grouping.set(next);
  _groupingChange$.next();
};

export const MOVE_GROUP_COLUMN = (columnId: number, destinationIndex: number): void => {
  const current = _grouping();
  const currentIndex = current.findIndex((_column) => _column.index === columnId);

  if (currentIndex === -1) {
    return;
  }

  const column = cloneDeep(current[currentIndex]);
  const next = [...current];

  next.splice(currentIndex, 1);
  next.splice(destinationIndex, 0, column);

  next.forEach((_column, _index) => {
    _column.groupIndex = _index;
  });

  _grouping.set(next);
  _groupingChange$.next();
};
